import { BrowserRouter } from "react-router-dom";
import { QueryProvider } from "./providers/QueryProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routing";
import ScrollToTop from "./lib/helpers/ScrollToTop";
import { CartInitializer } from "./components";

function App() {
  return (
    <QueryProvider>
      <BrowserRouter>
        <ScrollToTop />
        <CartInitializer />
        <AppRoutes />
        <ToastContainer position="top-right" autoClose={3000} />
      </BrowserRouter>
    </QueryProvider>
  );
}

export default App;
